import { CircularProgress } from "@material-ui/core";
import React, { FC, HTMLAttributes } from "react";

export const Loading: FC<HTMLAttributes<HTMLDivElement> & { size?: string; color?: string }> = ({ size, color, ...props }) => (
  <div {...props} style={{ ...props.style, ...(size ? { height: size } : {}) }}>
    <CircularProgress style={{ color: color }} size={size} />
  </div>
);
